<template>
    <div style="display:inline-block;">
        <slot/>
    </div>
</template>

<script>
export default {
    name : 'MessageCenter',

    mounted() {
        window.getUserToken = window._getUserToken;

        var _script = document.createElement("script");
        _script.src = "/ticket/message-center-js";
        document.body.appendChild( _script );
    }
}
</script>


// WEBPACK FOOTER //
// src/components/MessageCenter.vue